import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);
export class ChartObserver {
  constructor() {
    // Создаём экземпляр MutationObserver для наблюдения за добавлением новых элементов
    this.observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Проверяем, если это новый .chart
              if (node.matches('.chart')) {
                this.initializeChart(node);
              }

              // Если есть вложенные элементы .chart
              if (typeof node.querySelectorAll === 'function') {
                const chartElements = node.querySelectorAll('.chart');
                chartElements.forEach((chart) => {
                  this.initializeChart(chart);
                });
              }
            }
          });
        }
      });
    });

    // Запуск наблюдения за документом
    this.observeDocument();
  }

  observeDocument() {
    // Начинаем наблюдение за <body> для отслеживания новых элементов
    this.observer.observe(document.body, {
      childList: true,
      subtree: true, // Наблюдаем за всеми вложенными элементами
    });

    // Инициализируем Chart для уже существующих .chart
    document.querySelectorAll('.chart').forEach((chart) => {
      this.initializeChart(chart);
    });
  }

  initializeChart(chart) {
    // Если Chart уже инициализирован для этого контейнера, выходим
    if (!chart.chartInstance) {
      const data = JSON.parse(chart.dataset.all);
      const ctx = chart.getContext('2d');
      new Chart(ctx, data);
      chart.chartInstance = true; // Отмечаем, что Chart уже инициализирован
    }
  }
}

